import {Component, OnInit, ViewChild} from '@angular/core';
import {NotificationService} from "@shared/services/notification.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {ReportService} from "@modules/administration/report/services/report.service";
import {Subject} from "rxjs";
import {ReportConstant} from "@modules/administration/report/report.constant";
import {ReportModel} from "@modules/administration/report/interfaces/report.model";
import {FilterReportRequest} from "@modules/administration/report/interfaces/report.request";
import {debounceTime} from "rxjs/operators";
import {BaseResponse} from "@core/models/base-response.model";
import {MESSAGE_CODE} from "@shared/constants/message-code.constant";
import {differenceInCalendarDays} from "date-fns";
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexYAxis,
  ApexLegend,
  ApexXAxis,
  ApexFill,
  ApexTooltip,
  ApexTitleSubtitle
} from "ng-apexcharts";
import {CommonUtils} from "@shared/utils/utils";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  markers: any; //ApexMarkers;
  stroke: any; //ApexStroke;
  yaxis: ApexYAxis | ApexYAxis[];
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  legend: ApexLegend;
  fill: ApexFill;
  tooltip: ApexTooltip;
};

@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.css']
})
export class ViewReportComponent implements OnInit {
  readonly tableConfig = ReportConstant.TABLE_CONFIG;
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  reportList: ReportModel[] = [];
  filter: FilterReportRequest = new FilterReportRequest();
  totalOrder = 0;
  totalAmount = 0;
  dateOrder = [];
  listAmount = [];
  listOrder = []
  private filter$ = new Subject<any>();

  constructor(
    private notiService: NotificationService,
    private reportService: ReportService,
    private modalService: NzModalService,
  ) {
    this.chartOptions = {
      series: [
        {
          name: "Số đơn hàng",
          type: "column",
          data: this.listOrder
        },
        {
          name: "Doanh số",
          type: "line",
          data: this.listAmount
        }
      ],
      chart: {
        height: 400,
        type: "line",
        stacked: false
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: [1, 4]
      },
      title: {
        text: "Báo cáo doanh số",
        align: "left",
        offsetX: 110
      },
      xaxis: {
        categories: this.dateOrder
      },
      yaxis: [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            color: "#008FFB"
          },
          labels: {
            style: {
              colors: "#008FFB"
            }
          },
          title: {
            text: "Số đơn hàng",
            style: {
              color: "#008FFB"
            }
          },
          tooltip: {
            enabled: true
          }
        },

        {
          seriesName: "Doanh số",
          opposite: true,
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            color: "#00E396"
          },
          labels: {
            style: {
              colors: "#00E396"
            }
          },
          title: {
            text: "Doanh số",
            style: {
              color: "#00E396"
            }
          }
        }
      ],
      tooltip: {
        fixed: {
          enabled: true,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60
        }
      },
      legend: {
        horizontalAlign: "left",
        offsetX: 40
      }
    };
  }

  ngOnInit(): void {
    this.filter$
      .pipe(debounceTime(500))
      .subscribe((term) => {
        this.summaryOrder(true)
      });
  }

  summaryOrder(refresh: boolean = false, sort?: { sortBy: string, ascOrDesc: string }) {
    this.dateOrder = [];
    this.listOrder = [];
    this.listAmount = [];
    this.totalAmount = 0;
    this.totalOrder =0;
    this.tableConfig.loading = true;
    this.reportService.summaryOrder(this.filter).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.reportList = res.data;
        this.reportList.map(i => {
          this.dateOrder.push(i.dateOrder);
          this.listOrder.push(i.totalOrder);
          this.listAmount.push(i.totalAmount);
          this.totalOrder += i.totalOrder;
          this.totalAmount += i.totalAmount;
        })
        this.chartOptions.series = [
          {
            name: "Số đơn hàng",
            type: "column",
            data: this.listOrder
          },
          {
            name: "Doanh số",
            type: "line",
            data: this.listAmount
          }
        ]
        this.chartOptions.xaxis = {
          categories: this.dateOrder
        }
      }
      this.tableConfig.loading = false
    }, error => {
      this.tableConfig.loading = false
    }, () => this.tableConfig.loading = false);

  }

  disabledToDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.filter.fromDate) < 0;
  disabledFromDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.filter.toDate) > 0;

  filterChange($event) {
    this.filter$.next($event);
  }


}

